// This is just a dummy component to restrict the props
// that can be passed from outside of the Tabs component

import { FunctionComponent, ReactNode } from "react"

export interface ISwitchOptionProps {
    value: any
    disabled?: boolean
    tooltip?: ReactNode
    testId?: string

    // internal prop, do not use!
    __TYPE?: "SwitchOption"
}

const SwitchOption: FunctionComponent<React.PropsWithChildren<ISwitchOptionProps>> = () => {
    return null
}

export default SwitchOption
